<template>
  <div class="footer">
    <div class="container-fluid">
      <div class="justify-content-center">
        <a href="/">
          <img width="70px" class="rounded-circle mt-3" alt="logo" :src="this.$request + 'logo'" >
        </a>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 mt-3">
          <span @click="handleChangeLanguage('hy')" class="ml-5 text-light courser-pointer" :class="getCurrentLanguage() === 'hy' ? 'text-underline': ''">Հայ</span>
          <span @click="handleChangeLanguage('en')" class="ml-2 text-light courser-pointer" :class="getCurrentLanguage() === 'en' ? 'text-underline': ''">Eng</span>
          <span @click="handleChangeLanguage('ru')" class="ml-2 text-light mr-5 courser-pointer" :class="getCurrentLanguage() === 'ru' ? 'text-underline': ''">Рус</span>
          <p class="m-0 mt-2 wrapper">
            <a href="/">{{ $t('home_page') }} <b-icon icon="house-door" aria-hidden="true"></b-icon></a>
          </p>
          <p class="m-0 mt-2 wrapper">
            <a href="/shop">{{ $t('order') }} <b-icon icon="shop" aria-hidden="true"></b-icon></a>
          </p>
          <p class="mt-1 wrapper">
            <a href="/gallery">{{ $t('gallery') }} <b-icon icon="images" aria-hidden="true"></b-icon></a>
          </p>
        </div>
        <div class="col-12 col-sm-6 mt-3 mb-3">
          <div style="height: 100%;" class="contact">
            <div class="mb-3">
              <b-icon class="text-light" icon="telephone-fill" aria-hidden="true" />
              <a :href="'tel:'+getPhoneNumbers()[0]" class="ml-3 text-light">
                {{getPhoneNumbers()[0]}}
              </a>
              <a v-if="getPhoneNumbers()[1]" :href="'tel:'+getPhoneNumbers()[1]" class="ml-3 text-light">
                {{getPhoneNumbers()[1]}}
              </a>
            </div>
            <a :href="'viber://contact?number=%2B'+getPhoneNumbers()[0].substring(1)" target="_blank" class="mr-4"><img width="48" alt="viber" src="@/assets/icons8-viber.svg"></a>
            <a :href="'https://api.whatsapp.com/send?phone='+getPhoneNumbers()[0].substring(1)" target="_blank" class="mr-4"><img width="51" alt="whatsapp" src="@/assets/icons8-whatsapp.svg"></a>
            <a href="https://www.facebook.com/PaninoAm/" target="_blank"><img width="48" alt="messenger" src="@/assets/icons8-facebook-messenger.svg"></a>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; padding: 0; margin: 0; font-size: 12px; background-color: rgba(16,16,16,0.5); color: #a6a8a9">Developed by <a target="_blank" href="https://parallax.solutions" style="color: #7c7e7f">PARALLAX.SOLUTIONS</a></div>
  </div>
</template>

<script>
import Vue from "vue"

export default {
  name: "FooterComponent",
  // data(){
  //   return {
  //     viberSvg: require('./assets/icons8-viber.svg')
  //   }
  // },
  methods: {
    handleChangeLanguage(languageCode){
      this.$i18n.locale = languageCode
      Vue.$cookies.set("language", languageCode, '30d')
    },
    getCurrentLanguage(){
      return this.$i18n.locale
    },
    getPhoneNumbers(){
      if(this.$configs){
        return [this.$configs.fields.contact_number, this.$configs.fields.contact_number_second]
      }
      return []
    }
  }
}
</script>

<style scoped>
.footer{
  background-color: #5C3622;
}
.wrapper a{
  color: #bc8f4b !important;
  font-size: 20px;
  font-weight: bolder;
  font-style: italic;
}
.contact {
  height: 100%;
  margin: auto;
  top: 0;
}
.courser-pointer{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterComponent.vue